import { render, staticRenderFns } from "./PublicShare.vue?vue&type=template&id=0140126c&"
import script from "./PublicShare.vue?vue&type=script&lang=js&"
export * from "./PublicShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports